import { render, staticRenderFns } from "./InvitationTeamSection.vue?vue&type=template&id=4c0ad16b&"
import script from "./InvitationTeamSection.vue?vue&type=script&lang=js&"
export * from "./InvitationTeamSection.vue?vue&type=script&lang=js&"
import style0 from "./InvitationTeamSection.vue?vue&type=style&index=0&id=4c0ad16b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports